import { ErrorSuppressor } from '@infl-ts/util-embed-mode-provider';
import { foldQueryError } from '@infl-ts/util-make-apollo-decoded';
import { Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import { flow, identity, pipe } from 'fp-ts/function';
import * as NEA from 'fp-ts/NonEmptyArray';
import { formatValidationErrors } from 'io-ts-reporters';
import { Translation } from 'react-i18next';
import { logError } from './errors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Error = function Error(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "Error",
    "data-source-file": "display-query-error.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Typography, {
        sx: {
          whiteSpace: 'pre-wrap',
          my: 2
        },
        children: t(message)
      });
    }
  });
};

export var logQueryError = function logQueryError(err) {
  return pipe(err, foldQueryError(flow(logError, function (e) {
    return e ? NEA.of(e) : null;
  }), flow(function (e) {
    return formatValidationErrors(e, {
      truncateLongTypes: false
    });
  }, A.mapWithIndex(function (_, e) {
    return logError(e);
  }), A.filter(function (code) {
    return code !== undefined && code !== null;
  }), A.match(function () {
    return undefined;
  }, identity)), flow(logError, function (e) {
    return e ? NEA.of(e) : null;
  })));
};
export var DisplayQueryError = function DisplayQueryError(_ref2) {
  var message = _ref2.message,
      err = _ref2.err,
      refreshing = _ref2.refreshing,
      _children = _ref2.children;
  logQueryError(err);
  return /*#__PURE__*/_jsx(ErrorSuppressor, {
    "data-element": "ErrorSuppressor",
    "data-component": "DisplayQueryError",
    "data-source-file": "display-query-error.tsx",
    children: /*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "DisplayQueryError",
      "data-source-file": "display-query-error.tsx",
      children: function children(t) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [refreshing ? /*#__PURE__*/_jsx(Typography, {
            children: t('New data is being loaded')
          }) : null, pipe( /*#__PURE__*/_jsx(Error, {
            message: message !== null && message !== void 0 ? message : ''
          }), function (message) {
            return _children ? _children(message) : message;
          }, function (message) {
            return message;
          })]
        });
      }
    })
  });
};